<div class="configuration-option-select-advanced-fsd">
    <div class="configuration-option-select-advanced-fsd__container">
        <div class="configuration-option-select-advanced-fsd__text-container">
            <h2 i18n="@@configurator.fsd.autopilot.heading">Included by default</h2>
            <p i18n="@@configurator.fsd.autopilot.text">
                Autopilot enables your car to automatically steer and accelerate and brake for other vehicles or
                pedestrians in the same lane.
            </p>

            <h2 i18n="@@configurator.fsd.main.heading">Full Self-Driving</h2>
            <ul>
                <li i18n="@@configurator.fsd.main.list.one">
                    Navigate with Autopilot: automatically drive while on the highway, including overtaking other
                    vehicles.
                </li>
                <li i18n="@@configurator.fsd.main.list.two">
                    Auto Lane Change: automatically switch between lanes while driving on the highway.
                </li>
                <li i18n="@@configurator.fsd.main.list.three">Autopark: your Tesla parks itself automatically.</li>
                <li i18n="@@configurator.fsd.main.list.four">
                    Summon: your car meets you where you are (over small distances only currently).
                </li>
                <li i18n="@@configurator.fsd.main.list.five">
                    Your Tesla recognises traffic lights and stop signs, and is able to react to them.
                </li>
            </ul>

            <h3 i18n="@@configurator.fsd.additional.heading">Coming soon</h3>
            <ul>
                <li i18n="@@configurator.fsd.additional.list.one">Autonomous driving away from the highway.</li>
                <li i18n="@@configurator.fsd.additional.list.two">
                    Advanced Summon: your car automatically finds you in the parking lot.
                </li>
            </ul>
        </div>

        <div class="configuration-option-select-advanced-fsd__video-container" role="presentation">
            <video
                src="assets/videos/autopilot.mp4"
                type="video/mp4"
                title="Autopilot / FSD visualization"
                autoplay
                loop
                playsinline
                muted
                oncanplay="this.play()"
                onloadedmetadata="this.muted = true"
            ></video>
        </div>
    </div>

    <mg-configurator-checkbox
        label="I want Full Self-Driving"
        i18n-label="@@configurator.fsd.checkbox.one.label"
        [description]="
            { optionName: 'autopilot', key: 'optionDescription', selectableOptionId: 'fsd' } | optionTranslation | async
        "
        [checkedValue]="true"
        [uncheckedValue]="false"
        [formControl]="fsdFormControl"
        [modalKeys]="
            assignedSelectableValues?.fsd
                ? [assignedSelectableValues.fsd.label, assignedSelectableValues.fsd.labelId]
                : []
        "
    ></mg-configurator-checkbox>

    <mg-configurator-checkbox
        label="I'll use the Full Self-Driving growth model"
        i18n-label="@@configurator.fsd.checkbox.two.label"
        [description]="
            { optionName: 'autopilot', key: 'optionDescription', selectableOptionId: 'growth-model' }
                | optionTranslation
                | async
        "
        [checkedValue]="true"
        [uncheckedValue]="false"
        [formControl]="growthModelFormControl"
        [isDisabled]="!fsdFormControlValue"
        [modalKeys]="
            assignedSelectableValues?.growthModel
                ? [assignedSelectableValues.growthModel.label, assignedSelectableValues.growthModel.labelId]
                : []
        "
    ></mg-configurator-checkbox>
</div>
